import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { Badge } from "@circleco/compass/components/Badge";

import { t } from "@/i18n-js/instance";
import { Tooltip } from "@/react/components/SettingsApp/CompassCompat/Tooltip";
import { isLegacyAccessSystemAvailable } from "@/react/helpers/accessGroups/accessGroupHelpers";

import { FormSection } from "./FormSection";
import { SwitchField } from "./SwitchField";

export const SpaceAccess = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  if (!isLegacyAccessSystemAvailable(currentCommunitySettings)) {
    return null;
  }

  return (
    <FormSection
      title={t("settings.access_groups.admin.legacy_access.title")}
      titleAdornment={
        <Tooltip
          content={t(
            "settings.access_groups.admin.legacy_access.legacy_tooltip",
          )}
        >
          <Badge
            variant="secondary"
            label={t("settings.access_groups.admin.legacy_access.legacy_badge")}
          />
        </Tooltip>
      }
    >
      <div className="flex flex-col gap-4">
        <SwitchField
          name="automatically_add_members_to_new_spaces"
          label={t(
            "space_groups.form.create.automatically_add_members_to_new_spaces",
          )}
          labelTooltip={t(
            "space_groups.form.create.automatically_add_members_to_new_spaces_tooltip",
          )}
        />
        <SwitchField
          name="add_members_to_space_group_on_space_join"
          label={t(
            "space_groups.form.create.add_members_to_space_group_on_space_join",
          )}
          labelTooltip={t(
            "space_groups.form.create.add_members_to_space_group_on_space_join_tooltip",
          )}
        />
      </div>
    </FormSection>
  );
};
